export default __webpack_public_path__ + "static/media/new_ECS_LOGO_LIGHT_highterresolution.7a10dd4a.png";